import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useTrackingCode } from 'react-hubspot-tracking-code-hook';

import { IS_PRODUCTION_ENV } from 'constants/env.constants';

export function useHubspotTracking() {
  const { setPathPageView, setTrackPageView } = useTrackingCode();
  const location = useLocation();

  useEffect(() => {
    if (!IS_PRODUCTION_ENV) return;

    const pageName = location.pathname + location.search;

    setPathPageView(pageName);
    setTrackPageView();
    // eslint-disable-next-line
  }, [location.pathname, location.search]);
}
